import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import { withTheme } from "@material-ui/core";
import renderIf from "render-if";
import TradeInHeader from "./TradeInHeader";

const Wrapper = styled.header`
  background-color: rgb(243, 243, 243);
  border: 1px solid rgb(235, 235, 235);
  padding: 20px;
`;

const LinkStyled = styled(Link)`
  text-decoration: none;
  color: inherit;
`;

const Content = styled.div`
  padding: 20px;
  box-sizing: border-box;
  max-width: 750px;
  margin: 0 auto;
`;

const Title = withTheme(
  styled(Typography).attrs({
    variant: "h1",
    color: "textSecondary"
  })`
    && {
      margin: 15px 0;
    }
  `
);

const PageHeader = ({
  title,
  subheader,
  subtitle,
  children,
  link,
  removeBranding,
  ...props
}) => {
  return (
    <div {...props}>
      <LinkStyled to={link}>
        <TradeInHeader removeBranding={removeBranding}/>
      </LinkStyled>
      <Wrapper>
        <Content>
          {renderIf(subheader)(
            <Typography color="primary" variant="h6">
              {subheader}
            </Typography>
          )}
          <Title>{title}</Title>
          {children}
          {renderIf(subtitle)(
            <Typography color="primary" variant="h6">
              {subtitle}
            </Typography>
          )}
        </Content>
      </Wrapper>
    </div>
  );
};

export default PageHeader;
